module.exports = __webpack_public_path__ + "static/wpack/extracted/youtubebbe203b7d7b67e75c648169e7680542a.svg";